import * as Sentry from "@sentry/gatsby";

Sentry.init({
	dsn: "https://890edcfc4c40b8a2b5a187ea761f6c11@o4510242799353856.ingest.us.sentry.io/4510242800795648",
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: true,
});
